/* Team 59: progressively enhance the native Shopify contact form. No data is stored. */
(() => {
  const initialise = (scope) => {
    const roots = [...scope.querySelectorAll('.team59-page')];
    if (scope.matches?.('.team59-page')) roots.unshift(scope);

    roots.forEach((root) => {
      if (root.dataset.team59Enhanced === 'true') return;

      const today = new Date();
      const maxDate = [today.getFullYear(), String(today.getMonth() + 1).padStart(2, '0'), String(today.getDate()).padStart(2, '0')].join('-');
      root.querySelectorAll('[data-team59-birthdate]').forEach((input) => { input.max = maxDate; });

      const form = root.querySelector('.team59-form');
      if (!form) return;
      const steps = [...form.querySelectorAll('fieldset.team59-section[data-team59-step]')];
      const progress = root.querySelector('[data-team59-progress]');
      const progressLabel = root.querySelector('[data-team59-progress-label]');
      const meter = root.querySelector('[data-team59-meter]');
      const controls = root.querySelector('[data-team59-controls]');
      const back = root.querySelector('[data-team59-back]');
      const next = root.querySelector('[data-team59-next]');
      const final = form.querySelector('[data-team59-final]');
      const links = [...root.querySelectorAll('button[data-team59-goto]')];

      // Missing markup or Shopify's success state keeps the original native form.
      if (steps.length !== 7 || steps.some((step, index) => step.dataset.team59Step !== String(index)) ||
          !progress || !progressLabel || !meter || !controls || !back || !next || !final ||
          links.length !== 7 || links.some((link, index) => link.dataset.team59Goto !== String(index))) return;

      const last = steps.length - 1;
      let current = 0;
      const firstInvalid = (container) => [...container.querySelectorAll('input, select, textarea')]
        .find((field) => field.willValidate && !field.validity.valid);

      const showStep = (index, moveFocus = true) => {
        current = index;
        steps.forEach((step, position) => { step.hidden = position !== current; });
        final.hidden = current !== last;
        back.hidden = current === 0;
        next.hidden = current === last;
        meter.max = steps.length;
        meter.value = current + 1;
        const legend = steps[current].querySelector('legend');
        progressLabel.textContent = `Step ${current + 1} of ${steps.length} · ${legend?.textContent.trim() || ''}`;
        links.forEach((link, position) => {
          if (position === current) link.setAttribute('aria-current', 'step');
          else link.removeAttribute('aria-current');
          if (steps[position].id) link.setAttribute('aria-controls', steps[position].id);
        });
        if (moveFocus) {
          legend?.focus({ preventScroll: true });
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          progress.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
        }
      };

      const showInvalid = (field) => {
        const index = steps.findIndex((step) => step.contains(field));
        if (index >= 0 && index !== current) showStep(index, false);
        field.scrollIntoView({ behavior: 'auto', block: 'center' });
        field.focus({ preventScroll: true });
        field.reportValidity();
      };

      const navigate = (index) => {
        if (!Number.isInteger(index) || index < 0 || index > last || index === current) return;
        // Moving backwards never blocks editing. Forward moves validate the step being left.
        if (index > current) {
          const invalid = firstInvalid(steps[current]);
          if (invalid) { showInvalid(invalid); return; }
        }
        showStep(index);
      };

      const handleClick = (event) => {
        if (!(event.target instanceof Element)) return;
        const button = event.target.closest('button');
        if (!button || !root.contains(button)) return;
        if (button === back) navigate(current - 1);
        else if (button === next) navigate(current + 1);
        else if (links.includes(button)) navigate(Number(button.dataset.team59Goto));
      };

      const handleSubmit = (event) => {
        if (current < last) {
          event.preventDefault();
          navigate(current + 1);
          return;
        }
        const invalid = firstInvalid(form);
        if (invalid) {
          event.preventDefault();
          showInvalid(invalid);
        }
        // A valid final submission continues through Shopify and its spam protection.
      };

      const handleEnter = (event) => {
        if (event.defaultPrevented || event.key !== 'Enter' || event.isComposing ||
            event.ctrlKey || event.metaKey || event.altKey || event.shiftKey || current === last) return;
        const target = event.target;
        if (!(target instanceof HTMLInputElement) || !steps[current].contains(target) ||
            /^(button|submit|reset|checkbox|radio|range|color|file|hidden|image)$/.test(target.type)) return;
        event.preventDefault();
        navigate(current + 1);
      };

      const serverInvalid = form.querySelector('[aria-invalid="true"]');
      const initial = serverInvalid ? steps.findIndex((step) => step.contains(serverInvalid)) : 0;
      showStep(Math.max(initial, 0), false);
      root.addEventListener('click', handleClick);
      form.addEventListener('submit', handleSubmit);
      form.addEventListener('keydown', handleEnter);
      progress.hidden = false;
      controls.hidden = false;
      form.noValidate = true;
      root.dataset.team59Enhanced = 'true';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise(document), { once: true });
  } else initialise(document);
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
